// extracted by mini-css-extract-plugin
module.exports = {"arrow":"PriceTransparencyPopover_arrow__gnXoK"};